const Footer : React.FunctionComponent = () => {
    return (
        <footer className="footer text-white text-center py-2 mt-4">
            <p className="footer-parish-title"> Farnost Hostěradice a Trstěnice</p>
            <p className="footer-parish-copyright">Copyright &copy; 2025 | <a href="/contacts" className="link text-white">Kontaktujte nás</a></p>
        </footer>
    )
}

export default Footer;